/* 
  TRADINGVIEW MARKET DASHBOARD + CAPITAL ACCUMULATION MODELER
  TradingView board similar to newhome/index.js
*/

import React, { useEffect } from 'react';
import { TrendingUp, DollarSign, Calendar, Percent, Info, BarChart2 } from 'lucide-react';

// TradingView Market Dashboard Component
export const TradingViewMarketDashboard = () => {
  // TradingView Widget Injection (similar to newhome implementation)
  useEffect(() => {
    // Check if the script is already injected to avoid duplicates
    if (document.getElementById('tradingview-widget-script-framehome')) return;

    const script = document.createElement('script');
    script.id = 'tradingview-widget-script-framehome';
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js';
    script.async = true;
    script.innerHTML = JSON.stringify({
      "colorTheme": "dark",
      "dateRange": "12M",
      "showChart": false,
      "locale": "in",
      "largeChartUrl": "",
      "isTransparent": true,
      "showSymbolLogo": true,
      "showFloatingTooltip": false,
      "width": "100%",
      "height": "500",
      "tabs": [
        {
          "title": "Indian Indices",
          "symbols": [
            { "s": "BSE:SENSEX", "d": "SENSEX" },
            { "s": "BSE:TECK", "d": "BSE IT" },
            { "s": "BSE:AUTO", "d": "AUTO" }
          ]
        },
        {
          "title": "Global Indices",
          "symbols": [
            { "s": "CAPITALCOM:US30", "d": "Dow Jones" },
            { "s": "CAPITALCOM:US500", "d": "S&P 500" },
            { "s": "CAPITALCOM:US100", "d": "Nasdaq 100" },
            { "s": "CAPITALCOM:UK100", "d": "FTSE 100" }
          ]
        },
        {
          "title": "Forex",
          "symbols": [
            { "s": "FX_IDC:USDINR", "d": "USD/INR" },
            { "s": "FX_IDC:EURINR", "d": "EUR/INR" },
            { "s": "FX_IDC:GBPINR", "d": "GBP/INR" },
            { "s": "FX:EURUSD", "d": "EUR/USD" }
          ]
        },
        {
          "title": "Commodities",
          "symbols": [
            { "s": "TVC:GOLD", "d": "Gold" },
            { "s": "TVC:SILVER", "d": "Silver" },
            { "s": "TVC:USOIL", "d": "Crude Oil" },
            { "s": "CAPITALCOM:NATURALGAS", "d": "Natural Gas" }
          ]
        }
      ]
    });

    const container = document.querySelector('.tradingview-widget-container-framehome__widget');
    if (container) {
      container.appendChild(script);
    }
  }, []);

  return (
    <section id="markets" className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8 relative z-10 bg-gradient-to-b from-[#010411] to-[#020516] border-t border-white/5">
      <div className="max-w-7xl mx-auto">

        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto space-y-5 mb-16">
          <span className="text-xs font-black uppercase tracking-[0.3em] text-cyan-500">
            <TrendingUp className="inline-block w-4 h-4 mr-2" />
            REAL-TIME MARKET INTELLIGENCE
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-white tracking-tight">
            Live Market Dashboard
          </h2>
          <p className="text-slate-400 text-base sm:text-lg">
            Stay updated with real-time market trends across global indices, forex, and commodities.
          </p>
        </div>

        {/* TradingView Widget Container */}
        <div className="tradingview-widget-container-framehome relative rounded-[24px] overflow-hidden border border-white/10 bg-[#05091e]/40 shadow-2xl">
          <div className="tradingview-widget-container-framehome__widget"></div>
          <div className="tradingview-widget-copyright absolute bottom-2 right-4 z-10">
            <a href="https://in.tradingview.com/" rel="noopener nofollow" target="_blank">
              <span className="text-cyan-400 text-[10px] hover:text-cyan-300 transition-colors">
                Track all markets on TradingView
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TradingViewMarketDashboard;
